import React from 'react';
import PublicNews from '../features/Gnn/components/PublicPage/PublicNews';
import UnderDevelopment from '../common/UnderDevelopment';
import Overlay from '../features/Chats/components/Overlay';
import linkwayGIF from '../assets/Linkway/LWGIF.gif';
import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';
const PublicPage = () => {
  //   return <PublicNews />;
  //   return <UnderDevelopment />;
  //   return <Overlay />;
  return (
    <>
     <PublicNews />
     {/* <Outlet /> */}
    </>
  );
};

export default PublicPage;
